module.exports = __webpack_public_path__ + "static/img/3.00d6bda9.png";